import { render, staticRenderFns } from "./seatSelection.vue?vue&type=template&id=6f68fa2d&scoped=true"
import script from "./seatSelection.vue?vue&type=script&lang=js"
export * from "./seatSelection.vue?vue&type=script&lang=js"
import style0 from "./seatSelection.vue?vue&type=style&index=0&id=6f68fa2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68fa2d",
  null
  
)

export default component.exports